module.exports = __webpack_public_path__ + "static/media/Logo-Zeposia.748e3589.png";